import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} props.header - Header content
 * @param {React.ReactNode} props.children - Panel content
 * @param {import('@fortawesome/fontawesome-common-types').IconDefinition} props.icon - FontAwesome icon definition
 * @returns {JSX.Element}
 */
export const AssistPanel = ({ header, children, icon }) => {
  return (
    <div className={styles['assist-panel']}>
      <div className={styles['header-icon']}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className={styles.content}>
        {header}
        <div className={styles['break-line']} />
        {children}
      </div>
    </div>
  );
};
